export const allFieldsFilled = (arr, exceptions) => {
  let areAllFieldsFilled = true;
  arr.forEach((el) => {
    Object.keys(el).forEach((key) => {
      if (!exceptions.includes(key)) {
        if (!el[key] || el[key] === "") {
          areAllFieldsFilled = false;
        }
      }
    });
  });
  return areAllFieldsFilled;
};

export const buildAddress = (address, withPostcode = false) => {
  const allowed = [
    "addressLine1",
    "town",
    "county",
    "country",
    withPostcode ? "postcode" : "",
  ];
  if (address) {
    return allowed
      .filter((key) => Object.keys(address).includes(key))
      .map((line) => {
        return address[line];
      })
      .join(", ");
  }
  return "";
};

export const getCandidateInitials = (inducteeName) =>
  inducteeName
    .split(" ")
    .map((n) => n[0])
    .join(".");
